// extracted by mini-css-extract-plugin
export default {"actionBtn":"ReportMenu_actionBtn__iuKGS"};